import React from 'react';
import { FaFacebook, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';



export default function Footer() {
  return (
		<div className="">

			<footer
				className="text-center text-lg-start text-white"
				style={{backgroundColor: "lightgray"}}
			>

			<div className="container p-4 pb-0">
				<section className="">
					<div className="row">
						<div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-1 mb-2">
							<h6 className="text-uppercase mb-4 font-weight-bold">
								IPC Global
							</h6>
							<p className="text-theme lh-base fw-normal">
							From our humble beginnings, we have grown to a nationwide firm with 4 offices and dozens of highly experienced consultants, 
							dedicated to the success of your data, analytics, and cloud initiatives.
							</p>
						</div>

						<hr className="w-100 clearfix d-md-none" />

						<div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-1 mb-2">
							<h6 className="text-uppercase mb-4 font-weight-bold">What we do</h6>
							<p className="text-theme mb-1 fw-normal">Qlik Data Analytics Platform</p>
							<p className="text-theme mb-1 fw-normal">Qlik Data Integration Platform</p>	 					
							<p className="text-theme mb-1 fw-normal">Amazon Web Services (AWS)</p>
							<p className="text-theme mb-1 fw-normal">DataRobot Enterprise AI</p>
							<p className="text-theme mb-1 fw-normal">and more...</p>
						</div>

						<hr className="w-100 clearfix d-md-none" />

						<div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-1 mb-3 lh-lg">
							<h6 className="text-uppercase mb-4">Contact</h6>
							<p className="text-theme fw-normal"> Main Office</p>
							<p className="text-theme fw-normal"> 4080 McGinnis Ferry Road</p>
							<p className="text-theme fw-normal"> Building 100, Suite 103</p>
							<p className="text-theme fw-normal"> Alpharetta, GA 30005</p>
						</div>

						<div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-1">
							<h6 className="text-uppercase mb-4 font-weight-bold">Follow us</h6>
							<a
								className="btn btn-primary btn-floating m-1"
								style={{backgroundColor: "#3b5998"}}
								href="https://www.facebook.com/IPCGlobalServices"
								target="_blank"
								rel="noreferrer"
								role="button"
								><FaFacebook /></a>

							<a
								className="btn btn-danger btn-floating m-1"
								href="https://www.youtube.com/channel/UC4Ix5E7ni01J99cMa7y9XAg"
								target="_blank"
								rel="noreferrer"
								role="button"
								><FaYoutube /></a>

							<a
								className="btn btn-primary btn-floating m-1"
								href="https://mobile.twitter.com/ipcglobalservic"
								target="_blank"
								rel="noreferrer"
								role="button"
								><FaTwitter /></a>

							<a
								className="btn btn-primary btn-floating m-1"
								href="https://www.linkedin.com/company/ipc-global/mycompany/verification/"
								target="_blank"
								rel="noreferrer"
								role="button"
								><FaLinkedin /></a>
						</div>
					</div>
				</section>
			</div>

			<div
					className="text-center p-3 pr-5"
					style={{backgroundColor: "rgba(0, 0, 0, 0.2)"}}
					>
				©  
				<a className="text-white" href="https://ipc-global.com/"
					> IPC Global</a
					>
			</div>
		</footer>
	</div>
  )
}